import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Attendee {
  id: number;
  name: string;
  email: string;
  status: string;
}

interface AuthContextType {
  token: string | null;
  attendee: Attendee | null;
  login: (token: string, attendee: Attendee) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [attendee, setAttendee] = useState<Attendee | null>(null);

  const login = (newToken: string, newAttendee: Attendee) => {
    setToken(newToken);
    setAttendee(newAttendee);
  };

  const logout = () => {
    setToken(null);
    setAttendee(null);
  };

  return (
    <AuthContext.Provider value={{ token, attendee, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}